import React, { Component } from 'react'
import { injectIntl, FormattedDate } from 'react-intl'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import Table from '../../components/TableV2'
import { setPageTitle } from '../../components/Utils'
import { getDateFromObjectIdString } from '../../utils/date'
import EditSample from './EditSample'
import * as Auth from '../../auth'
import { getSamplePoolTagsString } from './SampleDetails'

class ISamplesListDisplay extends Component {
	columns = {
		updated: {
			accessor: (sample) => sample.updatedBy?.date,
			queryProps: [{ updatedBy: ['date', 'name', 'email'] }],
			name: this.props.intl.formatMessage({
				id: 'samples.table.columns.updated'
			}),
			render: (sample) =>
				!!sample.updatedBy ?
					<FormattedDate
						value={sample.updatedBy?.date}
						year="numeric"
						month="2-digit"
						day="2-digit"
					/>
				:	'',
			type: 'Date'
		},
		created: {
			accessor: (sample) => sample.createdBy.date,
			queryProps: [{ createdBy: ['date', 'name', 'email'] }],
			name: this.props.intl.formatMessage({
				id: 'samples.table.columns.created'
			}),
			render: (sample) => (
				<FormattedDate
					value={sample.createdBy?.date}
					year="numeric"
					month="2-digit"
					day="2-digit"
				/>
			),
			type: 'Date'
		},
		createdBy: {
			accessor: (sample) => sample.createdBy.name,
			queryProps: [{ createdBy: ['date', 'name', 'email'] }],
			name: this.props.intl.formatMessage({
				id: 'samples.table.columns.createdBy'
			}),
			render: (sample) => sample.createdBy?.name || 'unknown'
		},
		updatedBy: {
			accessor: (sample) => sample.updatedBy?.name,
			queryProps: [{ updatedBy: ['date', 'name', 'email'] }],
			name: this.props.intl.formatMessage({
				id: 'samples.table.columns.updatedBy'
			}),
			render: (sample) => sample.updatedBy?.name || 'unknown'
		},
		lastReviewDate: {
			accessor: (sample) => sample.lastReviewDate,
			queryProps: ['lastReviewDate'],
			name: this.props.intl.formatMessage({
				id: 'samples.table.columns.lastReviewDate'
			}),
			render: (sample) =>
				!!sample.lastReviewDate ?
					<FormattedDate
						value={sample.lastReviewDate}
						year="numeric"
						month="2-digit"
						day="2-digit"
					/>
				:	'',
			type: 'Date'
		},
		hasReview: {
			accessor: (record) => record.hasReview,
			queryProps: ['hasReview'],
			name: this.props.intl.formatMessage({
				id: 'samples.table.columns.hasReview'
			}),
			render: (record) => {
				return record?.hasReview ?
						this.props.intl.formatMessage({ id: 'yes' })
					:	this.props.intl.formatMessage({ id: 'no' })
			},
			filters: [
				{
					text: this.props.intl.formatMessage({
						id: 'yes'
					}),
					value: true
				},
				{
					text: this.props.intl.formatMessage({
						id: 'no'
					}),
					value: false
				}
			],
			onFilter: (value, record) => {
				return record?.hasReview === value
			}
		},
		poolTags: {
			searchable: true,
			queryProps: [
				{
					poolTags: [
						'musicConcept',
						'genres',
						'subgenres',
						'tags',
						'intensities',
						'langs'
					]
				}
			],
			name: this.props.intl.formatMessage({
				id: 'samples.table.columns.poolTags'
			}),
			render: (record) => {
				return getSamplePoolTagsString(record)
			},
			accessor: (record) => getSamplePoolTagsString(record),
			type: 'String'
		}
	}

	render() {
		const {
			redirect,
			link,
			match,
			selectedId,
			onSelect,
			defaultColumns,
			defaultMobileColumns,
			storageKey,
			title,
			actions,
			data
		} = this.props

		let sel = null
		if (selectedId) {
			sel = selectedId
		} else if (match && match.params && match.params.sampleId) {
			sel = match.params.sampleId
		}

		const getSearchProps = (record) => {
			const searchableContent = [record.name, record.team?.path]
			searchableContent.push(getSamplePoolTagsString(record))
			searchableContent.push(record.poolTags?.musicConcept ?? '')
			return searchableContent
		}

		return (
			<Table
				rowKey="_id"
				columns={this.columns}
				defaultColumns={defaultColumns}
				defaultMobileColumns={defaultMobileColumns}
				link={link}
				path="/samples"
				teamProp={(record) => record.team}
				nameProp={(record) => record.name}
				nameQueryProps={['name']}
				searchProps={getSearchProps}
				selectedId={sel}
				redirect={redirect}
				onSelect={onSelect}
				storageKey={storageKey}
				match={match}
				queryType="samples"
				title={title}
				actions={actions}
				data={data}
			/>
		)
	}
}

export const SamplesListDisplay = injectIntl(ISamplesListDisplay)

class SamplesList extends Component {
	state = {
		newSampleModal: false
	}

	render() {
		const { match, intl } = this.props
		if (!match.params || !match.params.sampleId) {
			setPageTitle(intl, 'samples')
		}

		let actions = []

		if (Auth.hasAccess('sample:add', Auth.cache.user.teamId)) {
			actions.push({
				title: intl.formatMessage({ id: 'samples.actions.newSample' }),
				key: 'newSample',
				icon: faPlus,
				action: () => this.setState({ newSampleModal: true })
			})
		}

		return (
			<React.Fragment>
				<SamplesListDisplay
					actions={actions}
					title={intl.formatMessage({ id: 'samples.table.title' })}
					match={match}
					redirect
					defaultColumns={['name', 'team']}
					defaultMobileColumns={['name']}
					extraQueryProps={[]}
					storageKey="samplesList"
				/>
				{this.state.newSampleModal && (
					<EditSample
						onClose={() => this.setState({ newSampleModal: false })}
					/>
				)}
			</React.Fragment>
		)
	}
}

export default injectIntl(SamplesList)
